import {
  FaJsSquare,
  FaReact,
  FaNodeJs,
  FaDocker,
  FaAws,
  FaGithub,
  FaJira,
} from 'react-icons/fa';
import {
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiRedux,
  SiStyledcomponents,
  SiHtml5,
  SiSass,
  SiNestjs,
  SiTypeorm,
  SiPostgresql,
  SiMongodb,
  SiKubernetes,
  SiFigma,
  SiNotion,
  SiConfluence,
  SiGraphql,
  SiStorybook,
  SiJest,
  SiTestinglibrary,
} from 'react-icons/si';

export const techStackCategories = [
  {
    title: 'Programming Languages',
    skills: [
      { name: 'JavaScript', icon: FaJsSquare, color: '#f7df1e' },
      { name: 'TypeScript', icon: SiTypescript, color: '#3178c6' },
    ],
  },
  {
    title: 'Front-End Frameworks & Libraries',
    skills: [
      { name: 'React JS', icon: SiReact, color: '#61dafb' },
      { name: 'React Native', icon: FaReact, color: '#61dafb' },
      { name: 'Next.js', icon: SiNextdotjs, color: '#000000' },
      { name: 'Redux', icon: SiRedux, color: '#764abc' },
      {
        name: 'Styled-Components',
        icon: SiStyledcomponents,
        color: '#db7093',
      },
      { name: 'HTML5', icon: SiHtml5, color: '#e34f26' },
      { name: 'CSS/SCSS/SASS', icon: SiSass, color: '#cc6699' },
    ],
  },
  {
    title: 'Back-End & API Technologies',
    skills: [
      { name: 'Node.js', icon: FaNodeJs, color: '#339933' },
      { name: 'NestJS', icon: SiNestjs, color: '#e0234e' },
      { name: 'TypeORM', icon: SiTypeorm, color: '#fca121' },
      { name: 'GraphQL', icon: SiGraphql, color: '#e10098' },
      { name: 'REST-API', icon: FaNodeJs, color: '#339933' },
    ],
  },
  {
    title: 'Databases',
    skills: [
      { name: 'PostgreSQL', icon: SiPostgresql, color: '#336791' },
      { name: 'MongoDB', icon: SiMongodb, color: '#47a248' },
    ],
  },
  {
    title: 'Testing & Quality Assurance',
    skills: [
      { name: 'Storybook', icon: SiStorybook, color: '#ff4785' },
      { name: 'Jest', icon: SiJest, color: '#c21325' },
      {
        name: 'React Testing Library',
        icon: SiTestinglibrary,
        color: '#e33332',
      },
    ],
  },
  {
    title: 'Cloud, DevOps & Infrastructure',
    skills: [
      { name: 'Docker', icon: FaDocker, color: '#2496ed' },
      { name: 'Kubernetes', icon: SiKubernetes, color: '#326ce5' },
      { name: 'AWS', icon: FaAws, color: '#ff9900' },
      { name: 'Git / GitHub / GitLab', icon: FaGithub, color: '#181717' },
    ],
  },
  {
    title: 'Productivity & Collaboration Tools',
    skills: [
      { name: 'Notion', icon: SiNotion, color: '#000000' },
      { name: 'Jira', icon: FaJira, color: '#0052cc' },
      { name: 'Confluence', icon: SiConfluence, color: '#172b4d' },
      { name: 'Figma', icon: SiFigma, color: '#ff61f6' },
    ],
  },
];
